import React from 'react'
import { Map } from 'immutable'
import {
  getPrimaryCourse,
} from '../../services/content/index'
import {
  TYPE_CONTENT_SERIES,
  TYPE_CONTENT_VIDEO,
  TYPE_CONTENT_COURSE,
} from '../../services/content-type/index'
import Link from '../Link/index'
import Button, { TYPES } from '../Button/index'
import { ICON_TYPES } from '../Icon.v2/index'
import TileV2Tags from './Tile.v2Tags'
import {
  getTileV2MobileMetadataClass,
  handleRemoveFromContinueWatching,
  handleTileV2OnClick,
} from './utils'

function RemoveButton (props) {
  const {
    isContinueWatchingV3,
    isTouchable,
  } = props

  if (!isTouchable) {
    return null
  }

  if (!isContinueWatchingV3) {
    return null
  }

  return (
    <div className="tile-v2__bottom-metadata-remove-button">
      <Button
        className="tile-v2__bottom-metadata-remove-icon-button"
        onClick={() => handleRemoveFromContinueWatching(props)}
        type={TYPES.ICON}
        icon={ICON_TYPES.CLOSE}
      />
    </div>
  )
}

/**
 * The title rendered as a link
 * @param {Object} props - The props
 * @param {String} props.title - The content title
 * @param {String} props.url - The url of the content
 * @returns {JSX.Element|null} - The content title as a link
 */
function TitleLink (props) {
  const {
    title,
    url,
  } = props

  if (!title || !url) {
    return null
  }

  return (
    <Link
      to={url}
      className="tile-v2__bottom-metadata-title"
      onClick={(e) => handleTileV2OnClick(e, props)}
    >
      {title}
    </Link>
  )
}

function TileV2BottomMetadata (props) {
  const {
    data,
    displayMode,
    contentType,
    isTouchable,
    userLanguage,
    userNodeInfo,
  } = props
  const title = data.get('title', '')
  const featuredEpisode = Map.isMap(userNodeInfo) ? userNodeInfo.getIn(['featuredEpisode', 'data'], Map()) || Map() : Map()
  const featuredEpisodeInProgress = featuredEpisode.getIn(['feature', 'userMediaPosition', 'position'], 0) > 0
  const featuredEpisodeTitle = featuredEpisode.get('title', '')
  const featuredEpisodeUrl = featuredEpisode.get('path', '')
  const isVideo = contentType === TYPE_CONTENT_VIDEO
  const isSeries = contentType === TYPE_CONTENT_SERIES
  const isCourse = contentType === TYPE_CONTENT_COURSE
  let url = featuredEpisodeInProgress ? featuredEpisodeUrl : data.get('url', '')

  if (isVideo) {
    const primaryCourse = getPrimaryCourse({ data, userLanguage })
    url = primaryCourse ? primaryCourse.get('path', '') : url
  }

  if (!isVideo && !isSeries && !isCourse) {
    return null
  }

  return (
    <div className={getTileV2MobileMetadataClass({ baseClassName: 'tile-v2__bottom-metadata-metadata', displayMode })}>
      <div className="tile-v2__bottom-metadata-top">
        <TitleLink
          {...props}
          url={url}
          title={featuredEpisodeInProgress ? featuredEpisodeTitle : title}
        />
        <RemoveButton {...props} isTouchable={isTouchable} />
      </div>
      <div className="tile-v2__bottom-metadata-bottom">
        <TileV2Tags {...props} />
      </div>
    </div>
  )
}

function tileV2BottomMetadataTestPropsAreEqual (prevProps, nextProps) {
  const prevData = prevProps.data
  const nextData = nextProps.data
  const prevUserLanguage = prevProps.userLanguage
  const nextUserLanguage = nextProps.userLanguage
  const prevStaticText = prevProps.staticText
  const nextStaticText = nextProps.staticText
  const prevIsTouchable = prevProps.isTouchable
  const nextIsTouchable = nextProps.isTouchable
  return prevData.equals(nextData)
    && prevStaticText.equals(nextStaticText)
    && prevUserLanguage === nextUserLanguage
    && prevIsTouchable === nextIsTouchable
}

const MemoizedTileV2BottomMetadata = React.memo(
  TileV2BottomMetadata,
  tileV2BottomMetadataTestPropsAreEqual,
)

export default MemoizedTileV2BottomMetadata
